import CommonImg from "@/components/Common/Img";
import { cn } from "@/libs/utils";
import { ReactNode } from "react";

type Props = {
  icon: string;
  iconAlt: string;
  title: string;
  cardClassName?: string | any;
  titleClassName?: string | any;
  titleChildren?: ReactNode;
  children: ReactNode;
  childrenClassName?: string | any;
};
export default function DetailCard({
  icon,
  iconAlt,
  title,
  cardClassName,
  titleClassName,
  titleChildren,
  children,
  childrenClassName,
}: Props) {
  return (
    <div className={cn("col-span-2 flex flex-col", cardClassName)}>
      <div className="bg-white flex gap-2 items-center border-[1px] border-gray-D rounded-t-xl p-5">
        <CommonImg src={icon} alt={iconAlt} />
        {titleChildren ? (
          <div
            className={cn(
              "w-full text-sm text-gray-A font-semibold flex gap-[20px] items-center",
              titleClassName
            )}
          >
            {title}
            {titleChildren}
          </div>
        ) : (
          <div className="text-sm text-gray-A font-semibold">{title}</div>
        )}
      </div>
      <div
        className={cn(
          "h-[280px] overflow-auto bg-white border-[1px] border-t-0 border-gray-D rounded-b-xl p-5",
          childrenClassName
        )}
      >
        <div className="text-sm text-gray-A font-normal whitespace-pre-wrap">
          {children}
        </div>
      </div>
    </div>
  );
}
